import * as React from 'react';

import { Checkbox, MenuItem, Select, Toolbar, Typography } from '@mui/material';
import {
  CustomTableCellCheckBox,
  CustomTableCellDownload,
  CustomTableCellReportStatus,
  CustomTableCellRimStatus,
  CustomTableCellText,
  CustomTableCellTextNonValid,
  CustomTableSentDateAndRefresh
} from './material-ui-styles';

import { CommunicationOverviewRimItemForDisplay } from '../../../../store/details/overview/types';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { Paper, Table, TableBody, TableRow, SelectChangeEvent } from '@mui/material';
import { generateRimReports } from '../../../../store/details/overview/actions';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './overview.module.css';
import { BelfiusTooltip } from 'src/components/custom/belfius-tooltip';

interface Props {
  readonly title: string;
  readonly rows: CommunicationOverviewRimItemForDisplay[];
  readonly toggleItem: (id: number, rimList: CommunicationOverviewRimItemForDisplay[]) => void;
  readonly togleAll?: (checked: boolean) => void;
  readonly toggleAllChecked: boolean;
  readonly currentLanguage: string;
  readonly rimStatusChange: (id: number, status: string) => void;
  readonly generateRimReports: typeof generateRimReports;
  readonly handleDownloadClick: (amazonKey: string, filename: string) => void; // Handle independently
  readonly caseCode: string;
  readonly caseBlocked: boolean;
}

type AllProps = Props;

export class OverviewTableRim extends React.Component<AllProps> {
  private localization: Ii18n;
  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <Paper>
        <Toolbar className={styles.toolbar}>
          <Typography variant='h5' id='tableTitle'>
            {this.props.title}
          </Typography>
        </Toolbar>

        <Table className={styles.table}>
          <TableBody>
            {this.props.rows.map(row => {
              return (
                <TableRow hover key={row.id()}>
                  <CustomTableCellCheckBox padding='checkbox'>
                    <Checkbox
                      disabled={!row.canDelete() || this.props.caseBlocked}
                      checked={row.selected()}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { this.props.toggleItem(row.id(), this.props.rows); }}
                    />
                  </CustomTableCellCheckBox>
                  {!row.isValid() && <CustomTableCellTextNonValid component='th' scope='row'>
                    {`${row.id()} (${this.localization.getFormatedDate(row.date(), this.props.currentLanguage)})`}
                  </CustomTableCellTextNonValid>}

                  {row.isValid() && <CustomTableCellText component='th' scope='row'>
                    {`${row.id()} (${this.localization.getFormatedDate(row.date(), this.props.currentLanguage)})`}
                  </CustomTableCellText>}

                  <CustomTableCellReportStatus>
                    <RefreshIcon onClick={() => {
                      if (this.props.caseBlocked) { return; }
                      this.props.generateRimReports(this.props.caseCode, [row.id()]); }}>refresh</RefreshIcon>
                  </CustomTableCellReportStatus>

                  <CustomTableCellRimStatus>
                    <Select
                      value={row.rimStatus() || ''}
                      onChange={(event: SelectChangeEvent<string>) => {
                        if (this.props.caseBlocked) { return; }
                        this.props.rimStatusChange(row.id(), event.target.value);
                      }}
                      displayEmpty
                      className={styles.select}
                      disabled={!row.canDelete() || this.props.caseBlocked}
                    >
                      <MenuItem value='' key='' disabled>
                        {this.localization.get('overview.rim.rimStatus')}
                      </MenuItem>
                      {row.rimStatusList().filter(x => x.language === this.props.currentLanguage).map(o => <MenuItem value={o.typeCodeValue} key={o.typeCodeValue}>{o.translation}</MenuItem>)}
                    </Select>
                  </CustomTableCellRimStatus>
                  <CustomTableCellDownload component='th' scope='row'>
                    {row.amazonKey() ? <div className={styles.link} onClick={() => this.props.handleDownloadClick(row.amazonKey(), 'rim-' + row.id().toString())} >{this.localization.get('shared.download')}</div> : ''}
                  </CustomTableCellDownload>
                  <CustomTableCellDownload component='th' scope='row'>
                    {row.daccaDiyAmazonKey() ? <div className={styles.link} onClick={() => this.props.handleDownloadClick(row.daccaDiyAmazonKey(), 'dacca-diy-' + row.id().toString())}>{this.localization.get('shared.downloadDaccaDiy')}</div> : ''}
                    <br />
                    {row.daccaDiyAmazonKey() ? <div className={styles.link} onClick={() => this.props.handleDownloadClick(row.daccaFinAmazonKey(), 'dacca-fin-' + row.id().toString())}>{this.localization.get('shared.downloadDaccaFin')}</div> : ''}
                  </CustomTableCellDownload>
                  <CustomTableSentDateAndRefresh scope='row'>
                    {this.localization.getFormatedDateTime(row.sentOn(), this.props.currentLanguage)}
                  </CustomTableSentDateAndRefresh>
                  <CustomTableCellCheckBox>
                    {row.needsApproval() ?
                    <BelfiusTooltip title={row.createdByName()}>
                    <div>
                      <CheckCircleOutlineIcon
                        aria-owns='simple-menu'
                        aria-haspopup='true'>check_circle_outline</CheckCircleOutlineIcon>
                    </div>
                  </BelfiusTooltip> : '' }
                  </CustomTableCellCheckBox>
                  </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
